export default __webpack_public_path__ + "static/media/classroom.a04dae23.png";